import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Activity, TrendingUp, TrendingDown } from "lucide-react";
import { api } from "../../lib/api";
import { pcImageUrl, pcImageFallback } from "../../lib/pcImage";
import { useCurrency } from "../../context/CurrencyContext";

const resolveUrl = (url) => (url?.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`);

export default function TopMoversStrip() {
  const [movers, setMovers] = useState(null);
  const { format } = useCurrency();

  useEffect(() => {
    api.get("/dashboard/top-movers?days=7").then((res) => setMovers(res.data.movers)).catch(() => setMovers([]));
  }, []);

  if (!movers || movers.length === 0) return null;

  return (
    <section data-testid="top-movers-strip" className="mb-6 border border-white/10 bg-[#111113] rounded-2xl p-4">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2 mb-1">
        <Activity className="w-4 h-4 text-[#F59E0B]" /> Top Movers
        <span className="text-xs text-zinc-500 font-normal">biggest price changes · last 7 days</span>
      </h2>
      <p className="text-xs text-zinc-500 mb-3">Based on real market data snapshots for cards in your collection.</p>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {movers.map((m) => {
          const up = m.delta > 0;
          return (
            <Link key={m.card_id} to={`/card/${m.card_id}`} data-testid={`top-mover-${m.card_id}`} className="w-32 shrink-0 group">
              {m.image ? (
                <img
                  src={pcImageUrl(resolveUrl(m.image), "240")}
                  onError={pcImageFallback}
                  alt={m.name}
                  className="w-32 aspect-[3/4] object-cover rounded-lg border border-white/10 group-hover:border-[#F59E0B]/50 transition-colors"
                />
              ) : (
                <div className="w-32 aspect-[3/4] flex items-center justify-center text-[10px] text-zinc-600 border border-white/10 rounded-lg text-center px-2">{m.name}</div>
              )}
              <p className="text-[11px] text-zinc-300 mt-1.5 truncate font-medium">{m.name}</p>
              <span
                data-testid={`top-mover-pct-${m.card_id}`}
                className={`inline-flex items-center gap-1 text-[11px] font-mono-plex font-bold px-1.5 py-0.5 rounded mt-0.5 ${up ? "bg-emerald-500/10 text-emerald-300" : "bg-red-500/10 text-red-300"}`}
              >
                {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                {up ? "+" : ""}{m.pct}%
              </span>
              <p className="text-[10px] text-zinc-500 font-mono-plex mt-0.5">
                {format(m.previous_price)} → {format(m.current_price)}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
